export default {
  essential: {
    label: "Essential",
    flushingToilets: "Flushing Toilets",
    hygieneCleaningCooking: "Hygiene/Cleaning/Cooking",
    showering: "Showering",
  },
  nonEssential: {
    label: "Non Essential",
  },
  manualEssential: {
    label: "Manual Essential",
    cooking: "Cooking",
    cleanSurfaces: "Cleaning Surfaces",
    personalHygiene: "Personal Hygiene",
    showering: "Showering",
  },
  water_resiliency_features: {
    label: "Water Resilience Featuers",
    rainwater_harvesting_system:
      "Water storage tank, cistern or rainwater havesting system or cistern.",
    low_flush_toilet: "Low-flush toilets ",
    low_flush_showerhead: "Low-flush showerheads",
    greywater_treatment: "Greywater treatment and reuse system.",
    water_conservation: "Water conservation practices",
    low_flush_faucets: "Low-flush faucets",
  },
  options: [
    {
      text:
        "Water storage tank, cistern or rainwater harvesting system or cistern",
      value: "rainwater_harvesting_system",
    },
    {
      text:
        "Low-flush toilets (these are toilets that use at maximum of 1.6 gallons per flush)",
      value: "low_flush_toilet",
    },
    {
      text:
        "Low-flow showerheads (these are showerheads that use less than 2 gallons of water per minute)",
      value: "low_flush_showerhead",
    },
    {
      text:
        "Low-flow faucets (these are faucets that use a maximum of 1.5 gallons of water per minute) ",
      value: "low_flush_faucets",
    },
    {
      text: "Greywater treatment and reuse system.",
      value: "greywater_treatment",
    },
    {
      text: "Water conservation practices.",
      value: "water_conservation",
    },
  ],
};
